import { useDisplayCurrencyQueryParams } from '@/shared/composables/useDisplayCurrencyQueryParams.ts';
import type { UseExperienceAggregationsDisplayCurrencyOptions } from '@/shared/types/displayCurrency';
import { computed, toValue } from 'vue';

export function useAggregationDisplayCurrencyQueryParams(
  options: UseExperienceAggregationsDisplayCurrencyOptions = {},
) {
  const withDisplayCurrency = options.withDisplayCurrency ?? true;
  const displayCurrencyQueryParams = useDisplayCurrencyQueryParams();

  return computed(() => {
    if (!withDisplayCurrency) {
      return {};
    }

    const overrideIso = toValue(options.displayCurrencyIso);

    if (overrideIso) {
      return { display_currency: overrideIso };
    }

    return displayCurrencyQueryParams.value;
  });
}
